<template>
    <div v-if="!isButtonDisable && isAllowRedeem && isLoginAccount">
        <RedButton @click="clickRedeem()">
            <div v-html="buttonLbl"></div>
        </RedButton>
    </div>
    <div v-else>
        <div class="text-12 text-center text-a-red-d14545 pb-3" v-html="buttonLbl"></div>
        <DisableBtn v-if="isSubscription()" >{{ lbl.subscription.detail.buy_now }}</DisableBtn>
        <DisableBtn v-else-if="isTypeBuy()" >{{ lbl.redeem_button.buy }}</DisableBtn>
        <DisableBtn v-else >{{ lbl.redeem_button.default }}</DisableBtn>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import { CampaignType } from "@/helper/StaticValue.js";
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin';
//component
import RedButton from '@/components/Button/RedButton.vue';
import DisableBtn from '@/components/Button/DisableBtn.vue';

export default {
    name: "RedeemButton",
    mixins: [AuthStatusMixin, LocaleMixin, ModalMixin],
    components: {
        RedButton,
        DisableBtn,
    },
    props: {
        detailController: { type: Object, default: null },
        subScriptPackage: { type: Object, default: null }
    },
    data: function() {
        return {
            type: null,
            point: 0,
            pointType: '',
            quantity: 0,
            campaign: {},

            buttonClass: 'disable',
            buttonLbl: '',
            buttonInitiated: false,
            isAllowRedeem: false,
            isUseDefault: false
        };
    },
    created: function () {
        this.type = this.detailController.type;
        this.point = this.detailController.point;
        this.pointType = this.detailController.pointType;
        this.quantity = this.detailController.quantity;
        this.campaign = this.detailController.campaign;

        this.buttonLbl = this.lbl.redeem_button.default;
        this.isAllowRedeem = this.campaign.isConditionPass;
        this.isButtonDisable = !this.campaign.isConditionPass;
    },
    mounted: function () {
        this.initialRedeemButton();
        this.buttonClass = this.getRedeemButtonClass();
        this.buttonLbl = this.cleanRedeemButtonLabel();
    },
    methods: {
        //Event
        clickRedeem: function () {
            if (this.isAllowRedeem) {
                if (this.isLogin) {
                    this.$emit('clickRedeem');
                } else {
                    this.modal.alertModal
                        .clearModal()
                        .setTitle(this.lbl.redeem_button.alert_headline)
                        .setMsg(this.lbl.redeem_button.alert_login_msg)
                        .setBtnOk(this.lbl.redeem_button.alert_ok_btn)
                        .setTag('redeem-btn')
                        .show();

                    this.modal.alertModal
                        .onClickOk(() => {
                            this.$router.push('/register');
                        });
                }
            }
        },
        //Function
        initialRedeemButton: function () {
            if (this.type == CampaignType.Buy) {
                this.buttonLbl = this.lbl.redeem_button.buy;
            }

            if (this.subScriptPackage) {
                this.buttonLbl = this.lbl.subscription.detail.get_plan;
            }

            //Check is campaign supported.
            if (this.type == CampaignType.Bid ||
                this.type == CampaignType.Event ||
                this.type == CampaignType.Media) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'notsupport';
                this.buttonLbl = this.lbl.redeem_button.notSupport;
            }

            //check published.
            if (this.campaign.statusID != 3) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'notpublish';
                this.buttonLbl = this.lbl.redeem_button.notPublish;
            }

            //Check expire date.
            if (this.campaign.currentDate > this.campaign.expireDate) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'expired';
                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.redeem_button.campaignExpiredBuy : this.lbl.redeem_button.campaignExpired;
            }
            //Check sold out.
            if (this.quantity <= 0) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "soldout";
                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.redeem_button.soldOutBuy : this.lbl.redeem_button.soldOut;
            }
            //Do validate when logged in.
            if (this.isLogin) {
                if (this.type == CampaignType.Buy && this.subScriptPackage && this.subScriptPackage.ExpireDate != null) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    this.buttonLbl = this.lbl.subscription.detail.buy_subscription;
                    // this.buttonLbl = this.lbl.redeem_button.already_buy;
                }
                //Check user enough point.
                if (this.point > this.userPoint) {
                    if (this.pointType && this.pointType != 'use') {
                        //Get point, do nothing.
                    } else {
                        this.isAllowRedeem = false;
                        this.isButtonDisable = true;
                        this.buttonClass = 'notenoughpoint';
                        this.buttonLbl = this.lbl.redeem_button.notEnoughPoint;
                    }
                }
                //Handle common case for custom text.
                if (!this.campaign.isConditionPass) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    //Use api text message.
                    if (this.isUseDefault) {
                        this.buttonClass = 'condition';
                        this.buttonLbl = this.campaign.conditionAlert;
                    } else {
                        switch (this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.buttonLbl = this.lblnone;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.buttonClass = "soldout";
                                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.redeem_button.soldOutBuy : this.lbl.redeem_button.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.buttonClass = "maxperson";
                                this.buttonLbl = this.lbl.redeem_button.maxPerPerson;
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.buttonClass = "cooldown";
                                this.buttonLbl = this.lbl.redeem_button.redeemCoolDown;
                                break;
                            case 4:
                                //Never see this.
                                this.buttonLbl = this.lbl.redeem_button.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.buttonClass = "eligible";
                                this.buttonLbl = this.lbl.redeem_button.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.buttonClass = "expired";
                                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.redeem_button.campaignExpiredBuy : this.lbl.redeem_button.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.buttonLbl = this.type == CampaignType.Buy ? this.lbl.redeem_button.campaignNotAvailableBuy : this.lbl.redeem_button.campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.buttonClass = "condition";
                                this.buttonLbl = this.campaign.conditionAlert;
                                break;
                        }
                    }
                } else {
                    this.buttonClass = 'allow';

                    if (this.campaign.customCaption) {
                        this.buttonLbl = this.campaign.customCaption;
                    }
                }
            } else {
                this.buttonClass = 'allow';

                if (this.campaign.customCaption) {
                    this.buttonLbl = this.campaign.customCaption;
                }
            }
            this.$nextTick(() => {
                this.buttonInitiated = true;
            });
        },
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.buttonLbl);
        },
        getRedeemButtonClass: function () {
            if (!this.isAllowRedeem)
                return this.buttonClass;

            return 'allow';
        },
        isTypeBuy: function () {
            return this.campaign.type == CampaignType.Buy;
        },
        isSubscription: function () {
            return this.subScriptPackage != null ? true : false;
        },
    }
}
</script>
<style lang="scss" scoped>
</style>
